export const QUOTE_PROJECT_TYPES = {
  fr: [
    'Une infrastructure vidéo WebRTC',
    'Une solution d’assistance vidéo',
    'Un espace de réunion ou bureau virtuel',
    'Une plateforme de rendez-vous vidéo',
    'Une diffusion live ou événement hybride',
    'Une intégration CRM, ticketing ou métier',
    'Un hébergement France ou on-premise',
  ],
  en: [
    'A WebRTC video infrastructure',
    'A video customer support solution',
    'A meeting room or virtual office',
    'A video appointment platform',
    'A live stream or hybrid event',
    'CRM, ticketing, or business tool integration',
    'France hosting or on-premise deployment',
  ],
};

export const QUOTE_SERVICE_OPTIONS = [
  { value: 'infrastructure_webrtc', label: 'Infrastructure vidéo WebRTC' },
  { value: 'assistance_video', label: 'Assistance vidéo' },
  { value: 'reunion_bureau_virtuel', label: 'Réunion ou bureau virtuel' },
  { value: 'rendez_vous_video', label: 'Rendez-vous vidéo' },
  { value: 'live_evenement', label: 'Live ou événement hybride' },
  { value: 'integration_metier', label: 'Intégration CRM, ticketing ou métier' },
  { value: 'hebergement_france_onprem', label: 'Hébergement France ou on-premise' },
  { value: 'autre', label: 'Autre projet vidéo métier' },
];

export const QUOTE_FAQ_ITEMS = {
  fr: [
    {
      question: 'Quel type de projet peut être étudié ?',
      answer:
        'Leagora étudie les projets d’infrastructure vidéo WebRTC, d’assistance client, de réunion ou bureau virtuel, de rendez-vous vidéo, de diffusion live, d’intégration CRM ou ticketing, ainsi que les déploiements en France ou en on-premise. Chaque demande est cadrée selon vos usages, volumes et contraintes SI.',
    },
    {
      question: 'Peut-on héberger la solution en France ?',
      answer:
        'Oui. Les déploiements peuvent être opérés sur une offre cloud en France ou en on-premise sur votre infrastructure, selon votre politique de résidence des données. Les engagements précis (localisation, sécurité, SLA) sont définis lors du cadrage projet.',
    },
    {
      question: 'Peut-on utiliser notre propre nom de domaine ?',
      answer:
        'Oui. Leagora permet de personnaliser l’accès vidéo avec votre nom de domaine, vos URL et votre identité visuelle, pour une expérience cohérente avec vos parcours clients ou internes.',
    },
    {
      question: 'Peut-on intégrer la vidéo dans un outil métier ?',
      answer:
        'Oui. L’infrastructure expose des API vidéo et des options d’intégration navigateur (lien, iframe, SDK) pour connecter la communication temps réel à un CRM, un portail client, un outil de ticketing ou une application métier existante.',
    },
    {
      question: 'Peut-on faire un pilote avant déploiement ?',
      answer:
        'Oui. Un pilote sur un périmètre limité (équipe, ligne produit ou parcours client) permet de valider l’usage, la qualité réseau et l’intégration avant un déploiement plus large. Le cadrage du pilote fait partie de l’échange initial.',
    },
  ],
  en: [
    {
      question: 'What types of projects can Leagora scope?',
      answer:
        'Leagora scopes WebRTC video infrastructure, customer video support, virtual meetings, video appointments, live streaming, CRM or ticketing integration, and France or on-premise hosting. Each request is framed around your use cases, volumes, and IT constraints.',
    },
    {
      question: 'Can the solution be hosted in France?',
      answer:
        'Yes. Deployments can run on a France cloud offer or on-premise on your infrastructure, depending on data residency policy. Location, security, and SLA commitments are defined during project scoping.',
    },
    {
      question: 'Can we use our own domain name?',
      answer:
        'Yes. Leagora supports branded video access with your domain, URLs, and visual identity for consistent customer or internal journeys.',
    },
    {
      question: 'Can video be embedded in a business tool?',
      answer:
        'Yes. The infrastructure exposes video APIs and browser integration options (link, iframe, SDK) to connect real-time communication to a CRM, customer portal, ticketing tool, or existing business application.',
    },
    {
      question: 'Can we run a pilot before full rollout?',
      answer:
        'Yes. A limited pilot (team, product line, or customer journey) validates usage, network quality, and integration before wider deployment. Pilot scope is part of the initial discussion.',
    },
  ],
};

export function getQuoteFaqItems(locale = 'fr') {
  return QUOTE_FAQ_ITEMS[locale] || QUOTE_FAQ_ITEMS.fr;
}

export function getQuoteProjectTypes(locale = 'fr') {
  return QUOTE_PROJECT_TYPES[locale] || QUOTE_PROJECT_TYPES.fr;
}
